import React from 'react';
import { COMPANY } from '../mock/data';
import { Reveal } from '../hooks/useReveal';
import SEO, { breadcrumbLd } from '../components/SEO';

const ImpressumPage = () => {
  return (
    <div className="bg-white pt-32 pb-24">
      <SEO
        title="Impressum · Frachigers Handwerk"
        description="Impressum und rechtliche Angaben von Frachigers Handwerk, Steckenmattstrasse 11, 6377 Seelisberg (Uri)."
        path="/impressum"
        noindex={false}
        jsonLd={[breadcrumbLd([{ name: 'Home', path: '/' }, { name: 'Impressum', path: '/impressum' }])]}
      />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="text-brand-blueLight uppercase tracking-[0.3em] text-xs mb-3 font-bold">Rechtliches</div>
          <h1 className="font-display text-5xl md:text-6xl text-brand-blueDark leading-tight mb-10 tracking-tight">Impressum</h1>
        </Reveal>

        <div className="space-y-8 text-brand-ink/85 leading-relaxed">
          <section>
            <h2 className="font-display text-xl text-brand-blueDark mb-2">Verantwortlich für den Inhalt</h2>
            <p><strong>Frachigers Handwerk</strong><br />
            Armin Achermann<br />
            Steckenmattstrasse 11<br />
            6377 Seelisberg<br />
            Schweiz</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-brand-blueDark mb-2">Kontakt</h2>
            <p>
              Telefon: <a href={`tel:${COMPANY.phoneInternational}`} className="text-brand-blue hover:text-brand-blueDark">{COMPANY.phone}</a><br />
              E-Mail: <a href={`mailto:${COMPANY.email}`} className="text-brand-blue hover:text-brand-blueDark">{COMPANY.email}</a><br />
              Website: {COMPANY.website}
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-brand-blueDark mb-2">Rechtsform</h2>
            <p>Einzelunternehmen · Inhaber Armin Achermann.</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-brand-blueDark mb-2">Haftungsausschluss</h2>
            <p>Der Autor übernimmt keinerlei Gewähr hinsichtlich der inhaltlichen Richtigkeit, Genauigkeit, Aktualität, Zuverlässigkeit und Vollständigkeit der Informationen. Haftungsansprüche gegen den Autor wegen Schäden materieller oder immaterieller Art, welche aus dem Zugriff oder der Nutzung bzw. Nichtnutzung der veröffentlichten Informationen, durch Missbrauch der Verbindung oder durch technische Störungen entstanden sind, werden ausgeschlossen.</p>
            <p className="mt-3">Alle Angebote sind unverbindlich. Der Autor behält es sich ausdrücklich vor, Teile der Seiten oder das gesamte Angebot ohne besondere Ankündigung zu verändern, zu ergänzen, zu löschen oder die Veröffentlichung zeitweise oder endgültig einzustellen.</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-brand-blueDark mb-2">Haftung für Links</h2>
            <p>Verweise und Links auf Webseiten Dritter liegen ausserhalb unseres Verantwortungsbereichs. Es wird jegliche Verantwortung für solche Webseiten abgelehnt. Der Zugriff und die Nutzung solcher Webseiten erfolgen auf eigene Gefahr des jeweiligen Nutzers.</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-brand-blueDark mb-2">Urheberrechte</h2>
            <p>Die Urheber- und alle anderen Rechte an Inhalten, Bildern, Fotos oder anderen Dateien auf dieser Website gehören ausschliesslich Frachigers Handwerk – Armin Achermann oder den speziell genannten Rechteinhabern. Für die Reproduktion jeglicher Elemente ist die schriftliche Zustimmung des Urheberrechtsträgers im Voraus einzuholen.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ImpressumPage;
